import apiClient from '../client';
import type { ProductScanSchema, WithPublicUserData } from '@appTypes';

// Products Scans API
export type { ProductScanSchema, WithPublicUserData } from '@appTypes';

type ScanWithUserData = WithPublicUserData<ProductScanSchema>;

/**
 * Fetch pending products scans (non-paginated)
 */
export async function fetchPendingProductsScans(): Promise<{ [key: string]: ScanWithUserData } | undefined> {
  const response: any = await apiClient.get('/fidelity/products-scans', {
    params: { paginated: false, status: 'Pending' },
  });
  return response.data;
}

/**
 * Fetch paginated products scans
 */
export async function fetchPaginatedProductsScans(params?: { lastDocumentId?: string }): Promise<{ data: { [key: string]: ScanWithUserData }; lastDocumentId?: string } | undefined> {
  const response: any = await apiClient.get('/fidelity/products-scans', {
    params: { paginated: true, lastDocumentId: params?.lastDocumentId },
  });
  return { data: response.data, lastDocumentId: response.lastDocumentId };
}

/**
 * Fetch paginated pending products scans
 */
export async function fetchPaginatedPendingProductsScans(params?: { lastDocumentId?: string }): Promise<{ data: { [key: string]: ScanWithUserData }; lastDocumentId?: string } | undefined> {
  const response: any = await apiClient.get('/fidelity/products-scans', {
    params: { paginated: true, lastDocumentId: params?.lastDocumentId, status: 'Pending' },
  });
  return { data: response.data, lastDocumentId: response.lastDocumentId };
}

/**
 * Get a specific product scan by ID
 */
export async function getProductScanById(params: { scanId: string }): Promise<ScanWithUserData | undefined> {
  const response: any = await apiClient.get(`/fidelity/products-scans/${params.scanId}`);
  return response.data;
}

/**
 * Validate a product scan
 */
export async function validateProductScan(params: { productScan: ScanWithUserData }): Promise<void> {
  await apiClient.post(`/fidelity/products-scans/${params.productScan.productScanId}/validate`, {
    productScan: params.productScan,
  });
}

/**
 * Reject a product scan
 */
export async function rejectProductScan(params: {
  productScan: ScanWithUserData;
  reason: { [key: string]: string };
}): Promise<void> {
  await apiClient.post(`/fidelity/products-scans/${params.productScan.productScanId}/reject`, {
    productScan: params.productScan,
    reason: params.reason,
  });
}
